<template>
  <div class="error-note" role="alert">
    <FontAwesomeIcon icon="exclamation-triangle" class="flex-shrink-0" />
    <div class="text-break"><slot /></div>
  </div>
</template>
